import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './assets/scss/_main-dir.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Router, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

ReactDOM.render( 
    <Router history={createBrowserHistory()}>
        <Route component={App}/>
    </Router>
, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
